import { Accordion, Panel } from 'baseui/accordion';
import { ChevronRight } from 'baseui/icon';
import accordionOverride from './accordion-override';
import { AccordionProps } from './accordion-props.interface';

export const AccordionComponent = ({
  panelList,
  accordion,
  disabled,
  iconSet,
  renderAll,
  initialState,
  overrides,
  onChange,
}: AccordionProps) => {
  return (
    <Accordion
      onChange={onChange}
      accordion={accordion}
      disabled={disabled}
      renderAll={renderAll}
      initialState={initialState}
      overrides={accordionOverride(iconSet, overrides)}
    >
      {panelList.map((item) =>
        item.externalRoute ? (
          <Panel
            overrides={{
              ToggleIcon: {
                component: () => <ChevronRight color='white' />,
              },
            }}
            onClick={item.onClick}
            title={item.title}
            key={item.key}
          >
            {item?.content}
          </Panel>
        ) : (
          <Panel overrides={overrides} title={item.title} key={item.key}>
            {item?.content}
          </Panel>
        )
      )}
    </Accordion>
  );
};

AccordionComponent.defaultProps = {
  accordion: true,
  disabled: false,
  iconSet: {
    upwards: 'arrow_upward',
    downwards: 'arrow_downward',
  },
  initialState: { expanded: [] },
  onChange: () => {
    return null;
  },
  overrides: {},
  panelList: [],
  renderAll: false,
};
